<footer class="footer" *ngIf="variant === 'default'">
  <div class="footer-content">
    <!-- Desktop: Link columns grid -->
    <div class="footer-columns-wrapper">
      <div class="footer-column" *ngFor="let column of columns">
        <h3 *ngIf="column.title" class="footer-column-title">{{ column.title | i18n }}</h3>
        <ul class="footer-column-links">
          <li *ngFor="let link of column.links">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer-column-link">
              {{ link.text | i18n }}
            </a>
          </li>
        </ul>
      </div>
      <!-- Reserved area for future content (badges, app downloads, QR codes) -->
      <div class="footer-reserved-area" aria-hidden="true"></div>
    </div>

  </div>
</footer>
<!-- Footer para as areas de login/register/forgetPassword... -->
<footer class="auth-footer" *ngIf="variant === 'auth'">
    <div class="auth-footer-links">
    <p>©{{ companyInfo.year }} {{ companyInfo.name }}. {{ 'components.footer.rightsReserved' | i18n }}</p>
      <div class="footer-links-group">
        <a *ngFor="let link of privacyLinks" [href]="link.url" target="_blank" rel="noopener noreferrer">
            {{ link.text | i18n }}
        </a>
      </div>
    </div>
</footer>
